module.exports = require("@pb/kit-util-show-tooltip");